const CONTENT_LOADER_TEMPLATE = `<div class="js__content-loader ui active inverted dimmer"><div class="ui text loader"></div></div>`;
export const showContentLoader = ($content) => {
    $content.parent().append(CONTENT_LOADER_TEMPLATE);
};
export const hideContentLoader = ($content) => {
    $content.parent().find('.js__content-loader').remove();
};
export const toggleContentLoader = ($content, state) => {
    if (state) {
        showContentLoader($content);
    }
    else {
        hideContentLoader($content);
    }
};
